import type { Modifier } from './modifier';
import type { Constructor } from './types';

export enum TraitType {
  // player archetypes -- an archetype id is the type of the trait it grants
  Anarchist = 'anarchist',
  Arbelist = 'arbelist',
  Archer = 'archer',
  Barbarian = 'barbarian',
  Bladestorm = 'bladestorm',
  Dryad = 'dryad',
  Fencer = 'fencer',
  Gladiator = 'gladiator',
  Knight = 'knight',
  ManaBorn = 'mana-born',
  Piper = 'piper',
  ShadowWalker = 'shadow-walker',
  SpellSlinger = 'spell-slinger',
  Tamer = 'tamer',
  Warrior = 'warrior',
  Wielder = 'wielder',

  // general
  Alluring = 'alluring',
  Brawler = 'brawler',
  NonMusical = 'non-musical',
  Swarm = 'swarm',

  // elementals
  AffinityEarth = 'affinity-earth',
  AffinityFire = 'affinity-fire',
  AffinityIce = 'affinity-ice',
  AffinityLightning = 'affinity-lightning',
  ElementalSynergy = 'elemental-synergy',

  // bosses
  Beholder = 'beholder',
  Cerberus = 'cerberus',
  CorestoneGuardian = 'corestone-guardian',
  Kraken = 'kraken',
  ManyHeads = 'many-heads',
  Phoenix = 'phoenix',
  Warden = 'warden',
}

export class TraitRegistry {
  private static registry: Map<string, any> = new Map();

  static register(type: TraitType, constructor: Constructor<Modifier>) {
    TraitRegistry.registry.set(type, constructor);
  }

  static get(type: TraitType) {
    return TraitRegistry.registry.get(type);
  }

  static getAll() {
    return Array.from(TraitRegistry.registry.entries());
  }
}
